import { _lang, lang } from '@umu/ukit-lang';

export * from './format';

/**
 * 获取当前时间戳，ms单位
 */
export function now() {
    return (Date.now && Date.now()) || new Date().getTime();
}

// 获取短时间版本
// 中文：1小时2分钟23秒
// 英文：1h 23m 23s
export function getTimeShortLang(seconds: number) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const second = Math.round(seconds % 60);

    if (!hours && !minutes && !second) {
        return lang('{$0{0=秒,1=秒}}_s', 0);
    }

    const timeArr = [];
    if (hours) {
        timeArr.push(lang('{$0{0=小时,1=小时}}_h', hours));
    }
    if (minutes) {
        timeArr.push(lang('{$0{0=分钟,1=分钟}}_m', minutes));
    }
    if (second) {
        timeArr.push(lang('{$0{0=秒,1=秒}}_s', second));
    }

    if (_lang('en')) {
        return timeArr.join(' ');
    }

    return timeArr.join('');
}
